<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <card-component titulo="Lista dos caps">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col mb-3">
                                <input-container-component titulo="Nome" id="inputNome">
                                    <input type="text" class="form-control" id="inputNome" placeholder="Informe o Nome"
                                        v-model="busca.nome" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col mb-3">
                                <input-container-component titulo="CNES" id="inputCnes">
                                    <input type="number" class="form-control" id="inputCnes"
                                        placeholder="Informe o CNES" v-model="busca.cnes" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                        </div>
                        <table-component :dados="caps.data" componentpai="caps" :editar="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalCapsAtualizar'
                        }" :remover="{ 
                            visivel: false,
                            dataToggle: 'modal',
                            dataTarget: '#modalCapsRemover'
                        }" :titulos="{
                            id: { titulo: 'ID', tipo: 'texto' },
                            nome: { titulo: 'Nome', tipo: 'texto' },
                            centro_custo: { titulo: 'Centro Custo', tipo: 'texto' },
                            cnes: { titulo: 'Cnes', tipo: 'texto' }
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-10">
                                <paginate-component>
                                    <li v-for="l, key in caps.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                            <div class="col-2">
                                <button type="submit" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalCaps">Adicionar</button>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>
        <modal-component id="modalCaps" titulo="Adicionar Caps">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Nome Caps" id="novoNome">
                        <input type="text" class="form-control" id="novoNome" placeholder="Informe o Nome do Caps"
                            v-model="nomeCaps">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Cnes Caps" id="novoCnes">
                        <input type="number" class="form-control" id="novoCnes" placeholder="Informe o Cnes Caps"
                            v-model="numeroCnes">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro Custo" id="novoCentroCusto">
                        <input type="text" class="form-control" id="novoCentroCusto" placeholder="Informe o Centro Custo"
                            v-model="centroCusto">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvar()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalCapsAtualizar" titulo="Atualizar Caps">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Caps atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Nome Caps" id="atualizarNome">
                        <input type="text" class="form-control" id="atualizarNome" placeholder="Informe o Nome do Caps"
                            v-model="$store.state.item.nome">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Cnes Caps" id="atualizarCnes">
                        <input type="number" class="form-control" id="atualizarCnes" placeholder="Informe o Cnes Caps"
                            v-model="$store.state.item.cnes">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro Custo" id="atualizarCentroCusto">
                        <input type="text" class="form-control" id="atualizarCentroCusto" placeholder="Informe o Centro Custo"
                            v-model="$store.state.item.centro_custo">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarCaps()">Atualizar</button>
            </template>
        </modal-component>

        <modal-component id="modalCapsRemover" titulo="Remover Caps">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Caps removido com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao remover."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo v-if="$store.state.transacao.status != 'sucesso'">
                <div class="form-group">
                    <input-container-component titulo="Nome Caps" id="removerNome">
                        <input type="text" class="form-control" id="removerNome" :value="$store.state.item.nome"
                            disabled>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Cnes Caps" id="removerCnes">
                        <input type="number" class="form-control" id="removerCnes" :value="$store.state.item.cnes"
                            disabled>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Centro Custo" id="removerCentroCusto">
                        <input type="text" class="form-control" id="removerCentroCusto" :value="$store.state.item.centro_custo"
                            disabled>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape> 
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-danger" @click="removerCaps()"
                    v-if="$store.state.transacao.status != 'sucesso'">Remover</button>
            </template>
        </modal-component>
    </div>
</template>

<script>
export default {
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        }
    },
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/caps',
            urlPaginacao: '',
            urlFiltro: '',
            nomeCaps: '',
            numeroCnes: '',
            centroCusto: '',
            transacaoStatus: '',
            transacaoDetalhes: {},
            caps: { data: [] },
            busca: { cnes: '', nome: '' }
        }
    },
    methods: {
        atualizarCaps() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('nome', this.$store.state.item.nome)
            formData.append('cnes', this.$store.state.item.cnes)
            formData.append('centro_custo', this.$store.state.item.centro_custo)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        removerCaps() {
            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data.mensagem
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    filtro += chave + ':like:' + this.busca[chave]
                }
            }
            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                this.urlFiltro = '&filtro=' + filtro + '%'
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = this.urlBase + '?' + this.urlPaginacao + this.urlFiltro

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.caps = response.data
                })
                .catch(errors => {
                })
        },
        salvar() {
            let formData = new FormData()

            formData.append('nome', this.nomeCaps)
            formData.append('cnes', this.numeroCnes)
            formData.append('centro_custo', this.centroCusto)

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.nomeCaps = ''
                    this.numeroCnes = ''
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: 'ID do registro: ' + response.data.id
                    }
                })
                .catch(errors => {
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        }
    },
    mounted() {
        this.carregarLista()
    }
}
</script>
